import React, { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Config from "../../config/Config";
import { useAppSelector } from "../../core/feature/hooks";
import User from "../../core/models/user";
import { StatsInvoice, StatsMessage } from "../common/home/Stats";
import users from "../../assets/images/icon_profile/user.svg";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { BackButton } from "../common/BackButton";

const ComponentAttendance = () => {
  const user: User = useAppSelector((state) => state.user.user);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const funBg = useMemo(() => {
    var str = "white";
    return "bg-" + str;
  }, []);
  const env = Config.BaseUrlDev;

  const getProfileImage = (photo: string) => {
    if (photo == "") return users;
    return env + "main_a/image/get/" + photo + "/pas";
  };

  const goToDetail = async (data: string) => {
    navigate(`/attendance-detail`, {
      state: {
        data: JSON.stringify(data),
        date: moment().format("yyyy-MM-DD"),
      },
    });
  };

  useEffect(() => {
    console.log(user.accounts[0].callerIdentities);
  }, []);
  return (
    <div className="bg-psp-primary pb-20">
      <StatsInvoice />
      <div className="container relative w-full -mt-44 bg-white shadow rounded-2xl pb-10">
        <div className="container h-full w-full">
          <div className="flex p-4">
            <BackButton />
            <div className="font-montserrat text-4xl font-bold my-2 ">
              {t("HOME.menu.account")}
            </div>
          </div>
          {user.accounts[0].callerIdentities.map((res: any, index: any) => {
            return (
              <div
                onClick={() => goToDetail(res)}
                className="cursor-pointer bg-white rounded-2xl shadow flex flex-row my-2.5 mx-6 px-2 py-3 justify-start"
                key={res.id}
              >
                <div>
                  <img
                    src={getProfileImage(res.photoUrl)}
                    className="w-[7vh] h-[7vh] rounded-full mx-3"
                  />
                </div>
                <div className="flex flex-col ml-4 justify-center">
                  <h1 className="font-montserrat text-sm  font-bold">
                    {res.name}
                  </h1>
                  <span className="font-montserrat  font-medium text-xs">
                    {t("INVOICE.nis")}: {res.callerId}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ComponentAttendance;
